import { useTranslation } from "react-i18next";
import { Inbox, Plus, SearchX } from "lucide-react";
import {
    Empty,
    EmptyDescription,
    EmptyHeader,
    EmptyMedia,
    EmptyTitle,
} from "@/components/ui/empty";
import { Button } from "@/components/ui/button";

export type RobotListEmptyStateProps = {
    hasRobots: boolean;
    onAddRobot: () => void;
    className?: string;
};

export const RobotListEmptyState = ({
    hasRobots,
    onAddRobot,
    className,
}: RobotListEmptyStateProps): JSX.Element => {
    const { t } = useTranslation();

    if (hasRobots) {
        return (
            <Empty className={className}>
                <EmptyHeader>
                    <EmptyMedia variant="icon" className="border-border bg-background border">
                        <SearchX />
                    </EmptyMedia>
                    <EmptyTitle>{t("page.robots.noResults.title")}</EmptyTitle>
                    <EmptyDescription>{t("page.robots.noResults.description")}</EmptyDescription>
                </EmptyHeader>
            </Empty>
        );
    }

    return (
        <Empty className={className}>
            <EmptyHeader>
                <EmptyMedia variant="icon" className="border-border bg-background border">
                    <Inbox />
                </EmptyMedia>
                <EmptyTitle>{t("page.robots.empty.title")}</EmptyTitle>
                <EmptyDescription>{t("page.robots.empty.description")}</EmptyDescription>
            </EmptyHeader>
            <Button onClick={onAddRobot}>
                <Plus size={16} className="mr-2" />
                {t("page.robots.empty.addRobot")}
            </Button>
        </Empty>
    );
};
